export default __webpack_public_path__ + "static/media/success-email-verification.7c778afb.png";